import { useTranslation } from 'react-i18next';
import { ButtonCore } from '@components/button-core';
import { IconCross } from '@components/icons/icon-cross';
import { IconWarning } from '@components/icons/icon-warning';
import LoaderSpinner from '@components/loader-spinner/loader-spinner';
import { ModalV2 } from '@components/modals/modal-v2/modal-v2';

import { FileDownloadModalProps } from './file-download-modal.type';

export const FileDownloadModal = ({
  status,
  onClose,
  downloadingTitle,
  downloadingDescription,
}: FileDownloadModalProps) => {
  const { t } = useTranslation();
  const isOpen = status !== 'idle';
  const isNotAvailable = status === 'not-available';

  return (
    <ModalV2
      isOpen={isOpen}
      onClose={isNotAvailable ? onClose : () => {}}
      closeOnBackdropClick={isNotAvailable}
      closeOnEscape={isNotAvailable}
      enableDragToClose={isNotAvailable}>
      <div className='flex flex-col gap-6 sm:gap-8 items-center pt-10 px-6 sm:px-20 sm:pt-12 pb-10 sm:pb-12 relative'>
        {isNotAvailable && (
          <div className='absolute top-4 right-4 sm:top-6 sm:right-6'>
            <button
              data-testid='file-download-modal__close-button'
              className='flex justify-center items-center p-1 hover:bg-transparent-10 rounded-lg transition-colors'
              onClick={onClose}
              aria-label='Close modal'>
              <IconCross className='text-primary w-6 h-6' />
            </button>
          </div>
        )}

        <div className='w-full flex flex-col gap-3 items-center'>
          {isNotAvailable ? (
            <>
              <IconWarning className='w-10 h-10 text-warning-no-bg' />
              <h2 className='text-center text-primary text-headline-m sm:text-headline-l'>
                {t('common:ticketNotAvailableTitle')}
              </h2>
              <p className='text-center text-secondary text-body-s'>{t('common:ticketNotAvailableDescription')}</p>
            </>
          ) : (
            <>
              <LoaderSpinner dataTestId='file-download-modal__loader' color='primary' size={10} />
              <h2 className='text-center text-primary text-headline-m sm:text-headline-l'>
                {downloadingTitle ?? t('common:ticketDownloadingTitle')}
              </h2>
              <p className='text-center text-secondary text-body-s'>
                {downloadingDescription ?? t('common:ticketDownloadingDescription')}
              </p>
            </>
          )}
        </div>

        {isNotAvailable && (
          <ButtonCore
            data-testid='file-download-modal__close-action'
            onClick={onClose}
            appearance='filled'
            variant='warning'
            className='w-full md:w-fit'>
            {t('common:closeLabel')}
          </ButtonCore>
        )}
      </div>
    </ModalV2>
  );
};
